import { render, staticRenderFns } from "./underwritingModel.vue?vue&type=template&id=4efb082e&scoped=true"
import script from "./underwritingModel.vue?vue&type=script&lang=js"
export * from "./underwritingModel.vue?vue&type=script&lang=js"
import style0 from "./underwritingModel.vue?vue&type=style&index=0&id=4efb082e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efb082e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4efb082e')) {
      api.createRecord('4efb082e', component.options)
    } else {
      api.reload('4efb082e', component.options)
    }
    module.hot.accept("./underwritingModel.vue?vue&type=template&id=4efb082e&scoped=true", function () {
      api.rerender('4efb082e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/underwritingManage/underwritingModel.vue"
export default component.exports